// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3JDmX","alertIcon":"ConfirmModal_alertIcon__2COJI"};